module.exports = __webpack_public_path__ + "media/images/powered-by-063ff02677735797803121d90f0630fd.svg";